<template>
  <div class="quotation-container">
    <div class="quotation-form">
      <h2>电子屏报价计算器</h2>
      
      <!-- 类型选择 -->
      <div class="form-group">
        <label>显示屏类型</label>
        <select v-model="formData.screenType">
          <option value="LED">LED显示屏</option>
          <!-- <option value="LCD">LCD显示屏</option>
          <option value="OLED">OLED显示屏</option> -->
        </select>
      </div>

      <!-- 应用场景 -->
      <div class="form-group">
        <label>应用场景</label>
        <select v-model="formData.scene" @change="sceneChange">
          <option value="indoor">室内LED</option>
          <option value="outdoor">室外LED</option>
          <option value="rental">租赁LED</option>
          <option value="originality">创意LED</option>
          <option value="transparent">透明LED</option>
          <option value="flexibility">柔性LED</option>
        </select>
      </div>
      
      <!-- 用途选择 -->
      <div class="form-group">
        <label>使用用途</label>
        <select v-model="formData.purpose">
          <option v-for="option in purposeOptions[formData.scene]" :key="option.value" :value="option.value">
            {{ option.label }}
          </option>
        </select>
      </div>
      
      <!-- 观看距离 -->
      <div class="form-group">
        <label>观看距离 (米)</label>
        <input type="number" v-model="formData.viewingDistance" min="1" placeholder="观看距离">
      </div>

      <!-- 尺寸输入 -->
      <div class="form-group size-inputs">
        <label>屏幕尺寸</label>
        <div class="size-group">
          <input type="number" v-model="formData.width" placeholder="宽度(mm)">
          <span>×</span>
          <input type="number" v-model="formData.height" placeholder="高度(mm)">
        </div>
      </div>

      <!-- 分辨率选择 -->
      <div class="form-group">
        <label>分辨率</label>
        <select v-model="formData.resolution">
          <option value="HD">HD (1280×720)</option>
          <option value="FHD">Full HD (1920×1080)</option>
          <option value="4K">4K (3840×2160)</option>
        </select>
      </div>

      <!-- 数量输入 -->
      <div class="form-group">
        <label>数量</label>
        <input type="number" v-model="formData.quantity" min="1">
      </div>

      <!-- 额外服务 -->
      <!-- <div class="form-group">
        <label>额外服务</label>
        <div class="checkbox-group">
          <label>
            <input type="checkbox" v-model="formData.services.installation">
            专业安装
          </label>
          <label>
            <input type="checkbox" v-model="formData.services.maintenance">
            维护服务
          </label>
          <label>
            <input type="checkbox" v-model="formData.services.contentDesign">
            内容设计
          </label>
        </div>
      </div> -->

      <!-- 按钮组 -->
      <div class="button-group">
        <button class="calculate-btn" @click="calculatePrice">获取报价</button>
        <button class="contact-btn" @click="contactSales">联系销售</button>
      </div>

      <!-- 报价结果 -->
      <div v-if="showResult" class="price-result">
        <h3>预估报价</h3>
        <div class="price-factors">
          <h4>价格影响因素</h4>
          <p><strong>用途：</strong> {{ getPurposeDescription() }}</p>
          <p><strong>观看距离：</strong> {{ getDistanceDescription() }}</p>
        </div>
        
        <div class="price-note">
          * 此报价为预估价格，实际价格可能会有所调整。如需详细报价，请联系销售。
        </div>
        <!-- 产品推荐列表 -->
        <div class="product-recommendations">
          <h4>推荐产品</h4>
          
          <div class="product-list">
            <div v-for="product in recommendedProducts" :key="product.id" class="product-card" :class="{'recommended': product.isRecommended}">
              <div class="product-header">
                <span v-if="product.isRecommended" class="recommended-badge">推荐选择</span>
                <h5>{{ product.name }}</h5>
              </div>
              
              <div class="product-content">
                <div class="product-flex-container">
                  <div class="product-image">
                    <img src="../images/jpg100-t4-width300.jpg" :alt="product.name">
                  </div>
                  
                  <div class="product-details">
                    <table class="product-table">
                        <tbody>
                      <tr>
                        <td class="label">型号:</td>
                        <td>{{ product.model }}</td>
                      </tr>
                      </tbody>
                      <tbody>
                      <tr>
                        <td class="label">用途:</td>
                        <td>{{ product.purpose }}</td>
                      </tr>
                      </tbody>
                      <tbody>
                      <tr>
                        <td class="label">观看距离:</td>
                        <td>{{ product.viewingDistance }}米</td>
                      </tr>
                      </tbody>
                      <tbody>
                      <tr>
                        <td class="label">柜体尺寸:</td>
                        <td>{{ product.size }}</td>
                      </tr>
                      </tbody>
                      <tbody>
                      <tr>
                        <td class="label">亮度:</td>
                        <td>{{ product.brightness }}</td>
                      </tr>
                      </tbody>
                      <tbody>
                      <tr>
                        <td class="label">放水级别:</td>
                        <td>{{ product.waterproofLevel }}</td>
                      </tr>
                      </tbody>
                      <tbody>
                      <tr class="price-row">
                        <td class="label">预估价格:</td>
                        <td class="price">¥{{ formatPrice(product.price) }}</td>
                      </tr>
                      </tbody>
                    </table>
                    
                    <div class="product-actions">
                      <button class="select-btn">选择此产品</button>
                      <button class="inquiry-btn">询价</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScreenQuote',
  data() {
    return {
      formData: {
        screenType: 'LED',
        scene: 'indoor',
        purpose: 'activity',
        viewingDistance: 5,
        width: '',
        height: '',
        resolution: 'FHD',
        quantity: 1,
        services: {
          installation: false,
          maintenance: false,
          contentDesign: false
        }
      },
      showResult: false,
      basePrice: 0,
      servicePrice: 0,
      totalPrice: 0,
      productImages: {
        LED: {
          indoor: '../images/jpg100-t4-width300.jpg',
          outdoor: '../images/jpg100-t4-width300 (1).jpg',
          rental: '../images/png100-t4-width300.png',
          originality: '../images/jpg100-t4-width300.jpg', // 创意LED图片
          transparent: '../images/jpg100-t4-width300 (1).jpg', // 透明LED图片
          flexibility: '../images/png100-t4-width300.png' // 柔性LED图片
        },
        LCD: {
          indoor: '../images/jpg100-t4-width300.jpg',
          outdoor: '../images/jpg100-t4-width300 (1).jpg',
          rental: '../images/png100-t4-width300.png',
          originality: '../images/jpg100-t4-width300.jpg',
          transparent: '../images/jpg100-t4-width300 (1).jpg',
          flexibility: '../images/png100-t4-width300.png'
        },
        OLED: {
          indoor: '../images/jpg100-t4-width300.jpg',
          outdoor: '../images/jpg100-t4-width300 (1).jpg',
          rental: '../images/png100-t4-width300.png',
          originality: '../images/jpg100-t4-width300.jpg',
          transparent: '../images/jpg100-t4-width300 (1).jpg',
          flexibility: '../images/png100-t4-width300.png'
        }
      },
      // 推荐产品列表
      recommendedProducts: [],
      // 各场景对应的用途选项
      purposeOptions: {
        indoor: [
          { value: 'activity', label: '活动' },
          { value: 'meeting', label: '会议室' },
          { value: 'church', label: '教堂' },
          { value: 'supermarket', label: '大型超市' },
          { value: 'dutyfree', label: '免税店' },
          { value: 'airport', label: '机场' },
          { value: 'stage', label: '室内舞台固定安装' },
          { value: 'companyMeeting', label: '公司会议室' }
        ],
        outdoor: [
          { value: 'billboard', label: '广告牌' },
          { value: 'signboard', label: '招牌' },
          { value: 'highway', label: '高速公路' },
          { value: 'stadium', label: '体育场馆' },
          { value: 'clinic', label: '家庭健康机构私人诊所' },
          { value: 'church', label: '教堂' },
          { value: '4sStore', label: '4S店' },
          { value: 'football', label: '美式足球' },
          { value: 'shop', label: '商店' },
          { value: 'school', label: '学校' },
          { value: 'mall', label: '美国商场' },
          { value: 'businessCenter', label: '商业中心' },
          { value: 'park', label: '公园' },
          { value: 'streetSign', label: '街道标志' }
        ],
        rental: [
          { value: 'activity', label: '活动' },
          { value: 'meeting', label: '会议室' },
          { value: 'church', label: '教堂' },
          { value: 'supermarket', label: '大型超市' },
          { value: 'dutyfree', label: '免税店' },
          { value: 'airport', label: '机场' },
          { value: 'stage', label: '室内舞台固定安装' },
          { value: 'companyMeeting', label: '公司会议室' }
        ],
        originality: [
          { value: 'creative', label: '创意' }
        ],
        transparent: [
          { value: 'window', label: '窗户' },
          { value: 'curtain', label: '窗帘' },
          { value: 'mall', label: '商场' },
          { value: 'olympics', label: '奥运会' },
          { value: '4sStore', label: '4S店' },
          { value: 'jewelryStore', label: '珠宝店' },
          { value: 'clothingStore', label: '服装店' },
          { value: 'hotel', label: '酒店' },
          { value: 'bar', label: '酒吧' },
          { value: 'concert', label: '演唱会' }
        ],
        flexibility: [
          { value: 'window', label: '窗户' },
          { value: 'curtain', label: '窗帘' },
          { value: 'mall', label: '商场' },
          { value: 'olympics', label: '奥运会' },
          { value: '4sStore', label: '4S店' },
          { value: 'jewelryStore', label: '珠宝店' },
          { value: 'clothingStore', label: '服装店' },
          { value: 'hotel', label: '酒店' },
          { value: 'bar', label: '酒吧' },
          { value: 'concert', label: '演唱会' },
          { value: 'poster', label: '海报' }
        ]
      }
    }
  },
  methods: {
    sceneChange(){
        this.formData.purpose = this.purposeOptions[this.formData.scene][0].value
    },
    calculatePrice() {
      // 基础单价（示例价格）
      const basePricePerSquareMeter = {
        LED: {
          indoor: 2000,
          outdoor: 3000,
          rental: 2500,
          originality: 3500,
          transparent: 4000,
          flexibility: 3800
        },
        LCD: {
          indoor: 3000,
          outdoor: 4000,
          rental: 3500,
          originality: 4500,
          transparent: 5000,
          flexibility: 4800
        },
        OLED: {
          indoor: 5000,
          outdoor: 6000,
          rental: 5500,
          originality: 7000,
          transparent: 8000,
          flexibility: 7500
        }
      }

      // 分辨率系数
      const resolutionCoefficient = {
        HD: 1,
        FHD: 1.3,
        '4K': 1.8
      }
      
      // 用途系数
    //   const purposeCoefficient = {
    //     media: 1.0,      // 媒体展示基准价格
    //     advertising: 1.2, // 广告宣传上浮20%
    //     stadium: 1.4,     // 体育场馆上浮40%
    //     conference: 1.1,  // 会议室上浮10%
    //     entertainment: 1.3 // 娱乐活动上浮30%
    //   }
      
      // 观看距离系数
      let distanceCoefficient = 1.0;
      if (this.formData.viewingDistance > 10) {
        distanceCoefficient = 0.9; // 观看距离大于10米，价格下调10%
      } else if (this.formData.viewingDistance < 3) {
        distanceCoefficient = 1.15; // 观看距离小于3米，价格上浮15%（需要更高清晰度）
      }

      // 计算面积（平方米）
      const area = (this.formData.width * this.formData.height) / 1000000
      
      // 计算基础价格
      this.basePrice = area * 
        basePricePerSquareMeter[this.formData.screenType][this.formData.scene] * 
        resolutionCoefficient[this.formData.resolution] *
        // purposeCoefficient[this.formData.purpose] *
        distanceCoefficient *
        this.formData.quantity

      // 计算服务费用
      this.servicePrice = 0
      if (this.formData.services.installation) {
        this.servicePrice += this.basePrice * 0.1 // 安装费用为基础价格的10%
      }
      if (this.formData.services.maintenance) {
        this.servicePrice += this.basePrice * 0.15 // 维护费用为基础价格的15%
      }
      if (this.formData.services.contentDesign) {
        this.servicePrice += this.basePrice * 0.05 // 内容设计费用为基础价格的5%
      }

      // 计算总价
      this.totalPrice = this.basePrice + this.servicePrice
      
      // 生成推荐产品列表
      this.generateRecommendedProducts()
      
      this.showResult = true
    },

    contactSales() {
      // 这里可以添加联系销售的逻辑，比如打开联系表单或显示联系信息
      alert('请联系我们的销售团队：\n电话：400-123-4567\n邮箱：sales@example.com')
    },

    formatPrice(price) {
      return price.toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },

    getPurposeDescription() {
      const purposeDescriptions = {
        media: "媒体展示 - 基准价格",
        advertising: "广告宣传 - 价格上浮20%（需要更高的吸引力和清晰度）",
        stadium: "体育场馆 - 价格上浮40%（需要更高的亮度和耐用性）",
        conference: "会议室 - 价格上浮10%（需要更好的色彩还原）",
        entertainment: "娱乐活动 - 价格上浮30%（需要更高的刷新率和动态表现）"
      };
      return purposeDescriptions[this.formData.purpose] || "标准用途";
    },
    
    getDistanceDescription() {
      if (this.formData.viewingDistance > 10) {
        return `${this.formData.viewingDistance}米 - 价格下调10%（远距离观看对分辨率要求较低）`;
      } else if (this.formData.viewingDistance < 3) {
        return `${this.formData.viewingDistance}米 - 价格上浮15%（近距离观看需要更高清晰度）`;
      } else {
        return `${this.formData.viewingDistance}米 - 标准观看距离`;
      }
    },
    
    // 获取产品图片
    getProductImage() {
      // 如果图片不存在，返回默认图片
      return this.productImages[this.formData.screenType]?.[this.formData.scene] || '/images/default-screen.jpg';
    },
    
    // 获取产品名称
    getProductName() {
      const typeNames = {
        LED: 'LED显示屏',
        LCD: 'LCD液晶显示屏',
        OLED: 'OLED有机显示屏'
      };
      
      const sceneNames = {
        indoor: '室内',
        outdoor: '户外',
        rental: '租赁',
        originality: '创意',
        transparent: '透明',
        flexibility: '柔性'
      };
      
      return `${typeNames[this.formData.screenType]} - ${sceneNames[this.formData.scene]}型`;
    },
    
    // 获取产品型号
    getProductModel() {
      const typePrefix = {
        LED: 'LD',
        LCD: 'LC',
        OLED: 'OL'
      };
      
      const sceneCode = {
        indoor: 'I',
        outdoor: 'O',
        rental: 'R'
      };
      
      const resolutionCode = {
        HD: 'H',
        FHD: 'F',
        '4K': '4K'
      };
      
      // 生成一个基于尺寸的唯一标识符
      const sizeCode = Math.round((this.formData.width * this.formData.height) / 10000);
      
      return `${typePrefix[this.formData.screenType]}-${sceneCode[this.formData.scene]}${resolutionCode[this.formData.resolution]}-${sizeCode}`;
    },
    
    // 获取用途文本
    getPurposeText() {
      const purposeTexts = {
        media: '媒体展示',
        advertising: '广告宣传',
        stadium: '体育场馆',
        conference: '会议室',
        entertainment: '娱乐活动'
      };
      
      return purposeTexts[this.formData.purpose] || '标准用途';
    },
    
    // 获取亮度
    getBrightness() {
      const brightnessValues = {
        LED: {
          indoor: '800-1200 nits',
          outdoor: '5000-7000 nits',
          rental: '1500-3000 nits',
          originality: '1000-2000 nits',
          transparent: '1200-2500 nits',
          flexibility: '800-1500 nits'
        },
        LCD: {
          indoor: '450-700 nits',
          outdoor: '2500-3500 nits',
          rental: '1000-1500 nits',
          originality: '600-1000 nits',
          transparent: '800-1200 nits',
          flexibility: '500-800 nits'
        },
        OLED: {
          indoor: '600-1000 nits',
          outdoor: '1500-3000 nits',
          rental: '1200-2000 nits',
          originality: '800-1500 nits',
          transparent: '1000-1800 nits',
          flexibility: '700-1200 nits'
        }
      };
      
      return brightnessValues[this.formData.screenType]?.[this.formData.scene] || '标准亮度';
    },
    
    // 获取放水级别
    getWaterproofLevel() {
      const waterproofLevels = {
        indoor: 'IP20 (一般室内防尘)',
        outdoor: 'IP65 (全天候防水防尘)',
        rental: 'IP54 (防溅水防尘)',
        originality: 'IP40 (创意应用防尘)',
        transparent: 'IP30 (透明屏幕有限防护)',
        flexibility: 'IP43 (柔性屏幕防尘防喷溅)'
      };
      
      return waterproofLevels[this.formData.scene] || '标准防护';
    },
    
    // 生成推荐产品列表
    generateRecommendedProducts() {
      // 清空之前的推荐产品
      this.recommendedProducts = [];
      console.log(this.totalPrice)
      // 添加当前选择的产品作为第一个推荐
      const mainProduct = {
        id: 1,
        name: this.getProductName(),
        model: this.getProductModel(),
        image: this.getProductImage(),
        purpose: this.getPurposeText(),
        viewingDistance: this.formData.viewingDistance,
        size: `${this.formData.width}mm × ${this.formData.height}mm`,
        brightness: this.getBrightness(),
        waterproofLevel: this.getWaterproofLevel(),
        price: this.totalPrice,
        isRecommended: true
      };
      
      this.recommendedProducts.push(mainProduct);
      
      // 添加其他推荐产品
      // 推荐1: 同类型但不同场景的产品
      const allScenes = ['indoor', 'outdoor', 'rental', 'originality', 'transparent', 'flexibility'];
      const scenes = allScenes.filter(s => s !== this.formData.scene);
      const alternativeScene = scenes[0];
      
      this.recommendedProducts.push({
        id: 2,
        name: `${this.formData.screenType}显示屏 - ${alternativeScene === 'indoor' ? '室内' : alternativeScene === 'outdoor' ? '户外' : '租赁'}型`,
        model: `${this.formData.screenType}-${alternativeScene.charAt(0).toUpperCase()}${this.formData.resolution}-${Math.round((this.formData.width * this.formData.height) / 10000)}`,
        image: this.productImages[this.formData.screenType][alternativeScene],
        purpose: this.getPurposeText(),
        viewingDistance: this.formData.viewingDistance,
        size: `${this.formData.width}mm × ${this.formData.height}mm`,
        brightness: alternativeScene === 'indoor' ? '800-1200 nits' : alternativeScene === 'outdoor' ? '5000-7000 nits' : '1500-3000 nits',
        waterproofLevel: alternativeScene === 'indoor' ? 'IP20 (一般室内防尘)' : alternativeScene === 'outdoor' ? 'IP65 (全天候防水防尘)' : 'IP54 (防溅水防尘)',
        price: this.totalPrice * (alternativeScene === 'outdoor' ? 1.2 : alternativeScene === 'rental' ? 1.1 : 0.9),
        isRecommended: false
      });
      
      // 推荐2: 不同类型的产品
      const types = ['LED', 'LCD', 'OLED'].filter(t => t !== this.formData.screenType);
      const alternativeType = types[0];
      
      this.recommendedProducts.push({
        id: 3,
        name: `${alternativeType === 'LED' ? 'LED显示屏' : alternativeType === 'LCD' ? 'LCD液晶显示屏' : 'OLED有机显示屏'} - ${this.formData.scene === 'indoor' ? '室内' : this.formData.scene === 'outdoor' ? '户外' : '租赁'}型`,
        model: `${alternativeType}-${this.formData.scene.charAt(0).toUpperCase()}${this.formData.resolution}-${Math.round((this.formData.width * this.formData.height) / 10000)}`,
        image: this.productImages[alternativeType][this.formData.scene],
        purpose: this.getPurposeText(),
        viewingDistance: this.formData.viewingDistance,
        size: `${this.formData.width}mm × ${this.formData.height}mm`,
        brightness: alternativeType === 'LED' ? '800-1200 nits' : alternativeType === 'LCD' ? '450-700 nits' : '600-1000 nits',
        waterproofLevel: this.getWaterproofLevel(),
        price: this.totalPrice * (alternativeType === 'OLED' ? 1.3 : alternativeType === 'LCD' ? 0.85 : 1),
        isRecommended: false
      });
    }
  }
}
</script>

<style scoped>
.quotation-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.quotation-form {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

h2 {
  text-align: center;
  color: #333;
  margin-bottom: 30px;
}

.form-group {
  margin-bottom: 20px;
}

label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-weight: 500;
}

select, input[type="number"] {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.size-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.size-group input {
  flex: 1;
}

.size-group span {
  color: #666;
}

.checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.checkbox-group label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-weight: normal;
}

.button-group {
  display: flex;
  gap: 15px;
  margin-top: 30px;
}

button {
  flex: 1;
  padding: 12px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.calculate-btn {
  background-color: #1890ff;
  color: white;
}

.calculate-btn:hover {
  background-color: #40a9ff;
}

.contact-btn {
  background-color: #f0f0f0;
  color: #333;
}

.contact-btn:hover {
  background-color: #e8e8e8;
}

.price-result {
  margin-top: 30px;
  padding: 20px;
  background-color: #f8f8f8;
  border-radius: 4px;
}

.price-details {
  margin: 15px 0;
}

.price-details p {
  margin: 8px 0;
  font-size: 16px;
}

.total-price {
  font-size: 20px !important;
  font-weight: bold;
  color: #1890ff;
}

.price-factors {
  margin: 15px 0;
  padding: 10px;
  background-color: #f0f7ff;
  border-radius: 4px;
  border-left: 3px solid #1890ff;
}

.price-factors h4 {
  margin-top: 0;
  margin-bottom: 10px;
  color: #1890ff;
}

.price-factors p {
  margin: 8px 0;
  font-size: 14px;
}

/* 产品列表样式 */
.product-recommendations {
  margin-top: 30px;
}

.product-recommendations h4 {
  color: #333;
  font-size: 20px;
  margin-bottom: 20px;
}

.product-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.product-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.3s ease;
}

.product-card:hover {
  transform: translateY(-5px);
}

.product-card.recommended {
  border: 2px solid #1890ff;
}

.product-header {
  padding: 15px;
  background-color: #fafafa;
  border-bottom: 1px solid #f0f0f0;
  position: relative;
}

.product-header h5 {
  margin: 0;
  font-size: 18px;
  color: #333;
  padding-right: 100px;
}

.recommended-badge {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #1890ff;
  color: white;
  padding: 4px 12px;
  border-bottom-left-radius: 8px;
  font-size: 14px;
}

.product-content {
  padding: 20px;
}

.product-flex-container {
  display: flex;
  gap: 30px;
  align-items: flex-start;
}

.product-image {
  flex: 0 0 300px;
  height: 300px;
  border-radius: 4px;
  overflow: hidden;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-details {
  flex: 1;
  min-width: 0;
}

.product-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.product-table td {
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
}

.product-table .label {
  width: 100px;
  color: #666;
  font-weight: 500;
}

.price-row {
  font-size: 16px !important;
}

.price-row .price {
  color: #f5222d;
  font-weight: bold;
}

.product-actions {
  display: flex;
  gap: 15px;
  margin-top: 20px;
}

.select-btn,
.inquiry-btn {
  flex: 1;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.select-btn {
  background-color: #1890ff;
  color: white;
}

.select-btn:hover {
  background-color: #40a9ff;
}

.inquiry-btn {
  background-color: #f0f0f0;
  color: #333;
}

.inquiry-btn:hover {
  background-color: #d9d9d9;
}

.price-note {
  font-size: 12px;
  color: #666;
  margin-top: 10px;
  margin-bottom: 20px;
  /* text-align: center; */
}

/* 响应式布局 */
@media (max-width: 1200px) {
  .product-flex-container {
    flex-direction: column;
  }
  
  .product-image {
    flex: 0 0 auto;
    width: 100%;
    height: 250px;
  }
}

@media (max-width: 768px) {
  .quotation-container {
    padding: 10px;
  }
  
  .product-header h5 {
    font-size: 16px;
  }
  
  .product-content {
    padding: 15px;
  }
  
  .product-actions {
    flex-direction: column;
  }
  
  .select-btn,
  .inquiry-btn {
    width: 100%;
  }
}
</style>